import { useSearchParams } from 'react-router-dom'

export const useClearSearchParams = () => {
  const [params, setParams] = useSearchParams()
  if (params.get('two_factor')) {
    setParams('')
  }
}
